import { useState, useEffect } from 'react';
import { AuthorizedUser } from '../models/User';

interface UseDisclaimerReturn {
  showDisclaimer: boolean;
  acceptDisclaimer: () => void;
}

export const useDisclaimer = (user: AuthorizedUser | undefined): UseDisclaimerReturn => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    // Don't show disclaimer if user is already logged in
    if (user) {
      return;
    }
    
    const disclaimerAccepted = localStorage.getItem('disclaimerAccepted');
    if (!disclaimerAccepted) {
      setShowDisclaimer(true);
    }
  }, [user]);

  const acceptDisclaimer = () => {
    localStorage.setItem('disclaimerAccepted', 'true');
    setShowDisclaimer(false);
  };

  return {
    showDisclaimer,
    acceptDisclaimer
  };
};